// Small client-side CSV helpers (extracted from the payment plan
// authorization evidence export in BillingTab).

export const csvEscape = (value) => {
  // Real numbers go out bare so Excel sums them. Routing them through the
  // formula guard below would turn -250 into the text '-250.
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  let stringValue = String(value ?? '').replace(/\r?\n/g, ' ');
  // Formula-injection guard: Excel/Sheets execute cells starting with
  // = + - @ as formulas even inside quoted CSV. Client-controlled values
  // (names, emails) land in these exports, so neutralize with a leading
  // apostrophe (renders as plain text).
  if (/^[=+\-@]/.test(stringValue)) {
    stringValue = `'${stringValue}`;
  }
  return `"${stringValue.replace(/"/g, '""')}"`;
};

// rows = array of arrays; header = array of column labels. CRLF line
// endings per RFC 4180 (what Excel expects).
export const buildCsv = (header, rows) =>
  [
    header.map(csvEscape).join(','),
    ...rows.map((row) => row.map(csvEscape).join(',')),
  ].join('\r\n');

export const downloadTextFile = ({ content, filename, type }) => {
  const blob = new Blob([content], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
